import styles from '../../index.module.scss';
import type { SmartImportChat } from '../useSmartImportChat';

export default function PayPeriodCard({ chat }: { chat: SmartImportChat }) {
	return (
		<div className={styles['action-card']}>
			<div className={styles['smart-import-card__buttons-wrap']}>
				{chat.payPeriodOptions.map((p) => (
					<button
						key={p.id}
						type="button"
						className={styles['action-card__confirm']}
						onClick={() => void chat.selectPayPeriod(p.id)}
					>
						{p.label}
					</button>
				))}
			</div>
		</div>
	);
}
